export const validateBannerLinkHandler = (link: string | null) => {
  if (!link) return link;
  if (link.startsWith('http://') || link.startsWith('https://')) {
    return link;
  }
  return link.startsWith('/') ? link : '/' + link;
};